function Section() {
  return (
    <>
      <section className="why-automate">
        <div id="features" className="why-automate-container">
          <div className="why-automate-card">
            <div className="card-item">
              <i className="fa fa-clock fa-icon"></i>
              <h3>Time-efficient</h3>
              <p>
                The system is designed to quickly and accurately identify individuals, reducing the
                time spent on taking attendance.
              </p>
            </div>
          </div>
          <div className="why-automate-card highlight">
            <div className="card-item">
              <i className="fa fa-window-restore fa-icon"></i>
              <h3>Responsive</h3>
              <p>
                The system is designed to be compatible with different screen sizes, devices, and
                web browsers, allowing for easy access and use on any device.
              </p>
            </div>
          </div>
          <div className="why-automate-card">
            <div className="card-item">
              <i className="fa fa-circle-user fa-icon"></i>
              <h3>User-friendly</h3>
              <p>
                The system features a simple and intuitive interface that makes it easy for users to
                navigate, understand, and use.
              </p>
            </div>
          </div>
          <div className="why-automate-card highlight">
            <div className="card-item">
              <i className="fa fa-server fa-icon"></i>
              <h3>Real-time</h3>
              <p>
                The system is designed to provide real-time updates on attendance, so users can stay
                on top of attendance data at all times.
              </p>
            </div>
          </div>
          <div className="why-automate-card">
            <div className="card-item">
              <i className="fa fa-circle-info fa-icon"></i>
              <h3>Time tracking</h3>
              <p>
                The system is designed to track the time when an individual is marked present, and
                generate reports on attendance times.
              </p>
            </div>
          </div>
          <div className="why-automate-card highlight">
            <div className="card-item">
              <i className="fa fa-leaf fa-icon"></i>
              <h3>Increased productivity</h3>
              <p>
                The system is designed to automate the attendance process and increase productivity
                by reducing manual tasks and errors
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Section;
